import { useState, useMemo, useCallback } from 'react';
import { DEFAULT_ITEMS_PER_PAGE } from '../constants/pagination';

/**
 * Custom hook para gerenciar estado e lógica de paginação
 * @param {Array} items - Array de itens a serem paginados
 * @param {number} initialItemsPerPage - Número inicial de itens por página
 * @returns {Object} Estado e funções de paginação
 */
export const usePagination = (items = [], initialItemsPerPage = DEFAULT_ITEMS_PER_PAGE) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);

  // Cálculos derivados memoizados
  const paginationData = useMemo(() => {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const currentItems = items.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

    return {
      totalPages,
      currentItems,
      totalItems: items.length
    };
  }, [items, currentPage, itemsPerPage]);

  // Função para mudar página
  const handlePageChange = useCallback((pageNumber) => {
    setCurrentPage(pageNumber);
  }, []);

  // Função para mudar itens por página
  const handleItemsPerPageChange = useCallback((newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset para primeira página
  }, []);

  // Reset para primeira página quando itens mudam
  const resetToFirstPage = useCallback(() => {
    setCurrentPage(1);
  }, []);

  return {
    // Estado
    currentPage,
    itemsPerPage,
    
    // Dados calculados
    ...paginationData,
    
    // Funções
    handlePageChange,
    handleItemsPerPageChange,
    resetToFirstPage
  };
}; 